export default __webpack_public_path__ + "static/media/female-test.c95e6d74.svg";